//remove the license key from the user object in local storage
export function removeLicenseKey() {
  const user = JSON.parse(localStorage.getItem("currentUser") || "{}");
  delete user.license;
  localStorage.setItem("currentUser", JSON.stringify(user));
}
